export default __webpack_public_path__ + "static/media/Scene 8.681d59f2.webp";